export const professionalCaptation = (state) => (id) => {
  if (state.professionalCaptation.idProfessional === id) {
    return state.professionalCaptation.data || {}
  }
  return {}
}
export const professionalCaptationId = (state) => {
  return state.professionalCaptation.idProfessional
}
export const professionalCaptationLoading = (state) => {
  return state.professionalCaptation.loading
}
export const professionalCaptationLastUpdate = (state) => {
  return state.professionalCaptation.lastUpdate
}

export const professionalSegmentations = (state) => (id) => {
  if (state.professionalSegmentations.idProfessional === id) {
    return state.professionalSegmentations.data || {}
  }
  return {}
}
export const professionalSegmentationsLoading = (state) => {
  return state.professionalSegmentations.loading
}
export const professionalSegmentationsLastUpdate = (state) => {
  return state.professionalSegmentations.lastUpdate
}

export const professionalSegmentationsHistorical = (state) => (id) => {
  if (state.professionalSegmentationsHistorical.idProfessional === id) {
    return state.professionalSegmentationsHistorical.data || {}
  }
  return {}
}
export const professionalSegmentationsHistoricalLoading = (state) => {
  return state.professionalSegmentationsHistorical.loading
}
export const professionalSegmentationsHistoricalLastUpdate = (state) => {
  return state.professionalSegmentationsHistorical.lastUpdate
}

export const valuationHolding = (state) => {
  return state.valuationHolding.data || {}
}
export const valuationHoldingLoading = (state) => {
  return state.valuationHolding.loading
}
export const valuationHoldingLastUpdate = (state) => {
  return state.valuationHolding.lastUpdate
}

export const PJPartnership =
  (state) =>
  ({ id }) => {
    if (!state.PJPartnership.data[id]) {
      return {}
    }
    return state.PJPartnership.data[id].data || {}
  }
export const PJPartnershipLoading =
  (state) =>
  ({ id }) => {
    if (!state.PJPartnership.data[id]) {
      return false
    }
    return state.PJPartnership.data[id].loading
  }
export const PJPartnershipLastUpdate =
  (state) =>
  ({ id }) => {
    if (!state.PJPartnership.data[id]) {
      return null
    }
    return state.PJPartnership.data[id].lastUpdate
  }

export const customers = (state) => {
  return state.customers.data || []
}
export const customersLoading = (state) => {
  return state.customers.loading
}
export const customersLastUpdate = (state) => {
  return state.customers.lastUpdate
}
export const familyGroup = (state) => {
  return state.familyGroup.data || []
}
export const familyGroupLoading = (state) => {
  return state.familyGroup.loading
}
export const familyGroupLastUpdate = (state) => {
  return state.familyGroup.lastUpdate
}

export const customersPartners = (state) => {
  return state.customersPartners.data || []
}
export const customersPartnersLoading = (state) => {
  return state.customersPartners.loading
}
export const customersPartnersLastUpdate = (state) => {
  return state.customersPartners.lastUpdate
}

export const calculator = (state) => {
  return state.calculator.data || []
}
export const calculatorLoading = (state) => {
  return state.calculator.loading
}
export const calculatorLastUpdate = (state) => {
  return state.calculator.lastUpdate
}

export const captable = (state) => {
  return state.captable.data || []
}
export const captableLoading = (state) => {
  return state.captable.loading
}
export const captableLastUpdate = (state) => {
  return state.captable.lastUpdate
}
export const captableFees = (state) => {
  return state.captableFees.data || []
}
export const captableFeesLoading = (state) => {
  return state.captableFees.loading
}
export const captableFeesLastUpdate = (state) => {
  return state.captableFees.lastUpdate
}
export const controlPartnership = (state) => {
  return state.controlPartnership.data || []
}
export const controlPartnershipLoading = (state) => {
  return state.controlPartnership.loading
}
export const controlPartnershipLastUpdate = (state) => {
  return state.controlPartnership.lastUpdate
}

export const controlSummary = (state) => {
  return state.controlSummary.data || []
}
export const controlSummaryLoading = (state) => {
  return state.controlSummary.loading
}
export const controlSummaryLastUpdate = (state) => {
  return state.controlSummary.lastUpdate
}
export const rankingCaptacao = (state) => {
  return state.rankingCaptacao.data || {}
}
export const rankingCaptacaoLoading = (state) => {
  return state.rankingCaptacao.loading
}
export const rankingCaptacaoLastUpdate = (state) => {
  return state.rankingCaptacao.lastUpdate
}

export const mixComments = (state) => {
  return state.mixComments.data || {}
}
export const mixCommentsLoading = (state) => {
  return state.mixComments.loading
}
export const mixCommentsLastUpdate = (state) => {
  return state.mixComments.lastUpdate
}

export const orcadoRealizado = (state) => {
  return state.orcadoRealizado.data || []
}
export const orcadoRealizadoLoading = (state) => {
  return state.orcadoRealizado.loading
}
export const orcadoRealizadoLastUpdate = (state) => {
  return state.orcadoRealizado.lastUpdate
}
